import { useEffect, useState } from 'react';
import { LocationApi } from '@/apis/location.api';
import { TreeDataNode } from 'antd';
import { DeviceFilterType } from '@/models/enums';
import { LocationResponseModel } from '@/models/location';

export const useLocationData = () => {
  const [isLoadingTree, setLoadingTree] = useState(false);
  const [locationData, setLocationData] = useState<LocationResponseModel[]>([]);
  const [treeData, setTreeData] = useState<TreeDataNode[]>([]);

  const fetchData = async () => {
    setLoadingTree(true);
    try {
      const { data: fetchedData } = await LocationApi.getLocations();
      if (fetchedData && fetchedData.length > 0) {
        setTreeData(convertToTreeData(fetchedData));
        setLocationData(fetchedData);
      } else {
        setTreeData([]);
        setLocationData([]);
      }
    } catch (error) {
      // Handle error (consider adding user feedback)
    } finally {
      setLoadingTree(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return { isLoadingTree, locationData, treeData, fetchData };
};

const convertToTreeData = (data: LocationResponseModel[]): TreeDataNode[] => {
  return data.map((item) => ({
    title: <span title={item.name}>{item.name}</span>,
    key: item.key ?? 'undefined',
    icon: <i className={checkIsLeadIcon(item.key, item.deviceFilterType ?? 1)} />,
    children: item.deviceFilterType !== 2 && item.children ? convertToTreeData(item.children) : undefined,
    parentId: item.parentId
  }));
};

const checkIsLeadIcon = (key: string | undefined, type: DeviceFilterType): string => {
  return type === DeviceFilterType.Merchant ? 'icon-folder' : 'icon-location';
};
